export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 15.0858C14.5 15.9767 15.5771 16.4229 16.2071 15.7929L18.7929 13.2071C19.1834 12.8166 19.1834 12.1834 18.7929 11.7929L16.2071 9.20711C15.5771 8.57714 14.5 9.02331 14.5 9.91421L14.5 15.0858Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12.5C4 12.2239 4.22386 12 4.5 12H14.5V13H4.5C4.22386 13 4 12.7761 4 12.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 12.5C3.5 11.9477 3.94772 11.5 4.5 11.5H15V13.5H4.5C3.94772 13.5 3.5 13.0523 3.5 12.5Z"
      fill="currentColor"
    />
  </svg>
);
